var ThemeDto = /** @class */ (function () {
    function ThemeDto(_a) {
        var name = _a.name, themeId = _a.themeId, previewUrl = _a.previewUrl, thumbUrl = _a.thumbUrl, largeThumbUrl = _a.largeThumbUrl, desc = _a.desc, branded = _a.branded;
        this.name = name;
        this.themeId = themeId;
        this.previewUrl = previewUrl;
        this.thumbUrl = thumbUrl;
        this.largeThumbUrl = largeThumbUrl;
        this.desc = desc;
        this.branded = branded;
    }
    ThemeDto.fromThemesPayload = function (_a) {
        var name = _a.name, theme_id = _a.theme_id, preview_url = _a.preview_url, thumb_url = _a.thumb_url, large_thumb_url = _a.large_thumb_url, desc = _a.desc, branded = _a.branded;
        return new ThemeDto({
            name: name,
            themeId: theme_id,
            previewUrl: preview_url,
            thumbUrl: thumb_url,
            largeThumbUrl: large_thumb_url,
            desc: desc,
            branded: branded,
        });
    };
    return ThemeDto;
}());
export { ThemeDto };
//# sourceMappingURL=ThemeDto.js.map